import { AbstractFieldReadComponent } from '../base-field/abstract-field-read.component';
import { Component } from '@angular/core';

@Component({
  selector: 'ccd-case-history-viewer-field',
  template: require('./case-history-viewer-field.component.html'),
})
export class CaseHistoryViewerFieldComponent extends AbstractFieldReadComponent {}
